<template>
  <ValidationProvider v-slot="{ errors }" :rules="rules" :name="label" :vid="name">
    <CContainer style="padding: 0px;">
      <CRow>
    <CCol sm="4" style="min-width: 100px;padding: 0px;" v-for="(option, index) in options" :key="index">
      <v-checkbox
        :key="index"
        color="primary"
        :value="option[valueKey]"
        v-model="localValue"
        :name="name"
        :error-messages="errors[0]"
        :readonly="readonly"
        :disabled="disabled"
        :data-vv-as="label"
        @change="onchange"
      >
        <div slot="label" :class="$style['label']">
          <span :class="$style['text']">
            <strong>{{ option[textKey] }}</strong>
          </span>
        </div>
      </v-checkbox>
      <div v-if="remarks" :class="$style['remarks']">{{remarks}}</div>
    </CCol>
      </CRow>
    </CContainer>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {},
    options: {
      type: Array,
      required: true
    },
    textKey: {
      type: String,
      required: true
    },
    valueKey: {
      type: String,
      required: true
    },
    rules: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    column: {
      type: Boolean,
      default: false
    },
    onchange: {
      default: () => {}
    },
    remarks: {
      type: String,
      default: ""
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value != null &&
          this.value[0] != null &&
          Object.prototype.toString.call(this.value[0]) === "[object Object]"
          ? this.value.map(val => {
              return val[this.valueKey];
            })
          : this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style module lang="scss">
.description {
  margin: 0;
}
.label {
  display: flex;
  align-content: center;
}
.image__radio {
  width: 30px;
  height: 30px;
  margin-right: 5px;
}
.text {
  display: flex;
  align-items: center;
}
.remarks {
  font-size: 12px;
  &:before {
    content: "※";
    margin-right: 4px;
  }
}
</style>
